import { BodyTypes } from '../LevelManager';
import { LaneEntitySpine } from './LaneEntitySpine';

export class BoostPadAnimated extends LaneEntitySpine {
  public boostSpeed: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'boost', 'boost', true);

    this.injectMatter(this as unknown as Phaser.GameObjects.GameObject);
  }

  public init() {}

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    let x = this.x;
    let y = this.y;

    this.scene.matter.add.gameObject(target, {
      label: BodyTypes.Boost,
      isStatic: true,
      isSensor: true
    }) as Phaser.Physics.Matter.Sprite;

    this.scene.matter.body.setPosition(target.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(target.body as MatterJS.BodyType, 0, 0);
  }
}
